export default "__VITE_ASSET__BGUE0pOd__";